import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Paper,
  LinearProgress,
  makeStyles,
  Button
} from '@material-ui/core';
import API from '../../api-graphql';
import Form from '../Form';
import { getDefaultSchema, defaultUISchema, customFormats } from './schema';
import { CONSTANTS } from '../../constants/constants';

const useStyles = makeStyles((theme) => ({
  paper: {
    maxWidth: '50%',
    margin: 'auto',
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(6))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(6)
    },
    [theme.breakpoints.down(600 + theme.spacing(6))]: {
      maxWidth: '100%'
    }
  },
  button: {
    margin: '2rem 1rem 0 0'
  }
}));

const UploadHash = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { config, history } = props;
  const { user, group, subgroup, extraConfig } = config;
  let schema = getDefaultSchema();
  let uiSchema = defaultUISchema;
  const formData = { hash: [''] };
  const customConfig = JSON.parse(extraConfig.data);

  if (extraConfig && customConfig.createHash && customConfig.createHash.schema) {
    schema = {
      ...schema,
      ...customConfig.createHash.schema,
      properties: {
        ...schema.properties,
        ...customConfig.createHash.schema.properties
      },
      required: Array.from(new Set(schema.required.concat(customConfig.createHash.schema.required || [])))
    };

    if (customConfig.createHash.uiSchema) {
      const _uiSchema = customConfig.createHash.uiSchema;
      uiSchema = {
        ...defaultUISchema,
        ..._uiSchema,
        'ui:order': _uiSchema['ui:order'] ? _uiSchema['ui:order'] : defaultUISchema['ui:order']
      };
    }
  }

  const handleSubmit = async ({ formData }) => {
    setLoading(true);

    const date = new Date();

    const input = {
      group,
      id: `${date.getTime()}_${user.username}`,
      name: formData.name,
      description: formData.description || '',
      status: CONSTANTS.DOCUMENT.STATUS.INIT,
      data: JSON.stringify(formData),
      createdAt: date.toISOString(),
      type: 'file',
      hash: Array.isArray(formData.hash) ? formData.hash.shift() : formData.hash,
      annexes: Array.isArray(formData.hash) ? formData.hash.map(i => ({
        description: '',
        name: `hash: ${i}`,
        path: i,
        skip: false })) : []
    };

    API.createDocument(input, subgroup)
      .then(() => {
        history.push('/file');
      })
      .catch(err => console.error('Error creating document', err));
  };

  if (loading) {
    return (
      <div style={
        {
          padding: 0,
          position: 'absolute',
          left: 0,
          width: '100%',
          zIndex: 9999
        }
      }
      >
        <LinearProgress />
      </div>
    );
  }

  return (
    <Paper className={classes.paper}>
      <Form
        schema={schema}
        uiSchema={uiSchema}
        formData={formData}
        onSubmit={handleSubmit}
        customFormats={customFormats}
      >
        <Button variant='outlined' className={classes.button} onClick={props.history.goBack}>
          {t('uploadHash:cancel')}
        </Button>
        <Button variant='contained' className={classes.button} type='submit' color='primary'>
          {t('uploadHash:createButton')}
        </Button>
      </Form>
    </Paper>

  );
};

const mapStateToProps = (state) => {
  return {
    config: state.config
  };
};

UploadHash.propTypes = {
  config: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default connect(mapStateToProps, null)(UploadHash);
